<script>
import WorkScheduleVisitCheckService from '@src/services/WorkScheduleVisitCheckService'
import swalFeedback from '@src/mixins/swalFeedback.vue'
import validation from '@src/mixins/validation.vue'
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'

const i18nKey = 'WORKSCHEDULES'
const i18nCommon = 'COMMON'

export default {
    mixins: [swalFeedback, validation],
    data() {
        return {
            i18nKey,
            i18nCommon,
            visible: false,
            submitLoading: false,
            mode: 'in',
            context: {
                date: null,
                workScheduleId: null,
                pointOfSaleId: null,
                pointOfSaleName: '',
                hash: null,
            },
            form: {
                datetime: '',
            },
        }
    },
    computed: {
        i18nTitle() {
            return this.mode === 'in'
                ? this.getI18n(i18nKey, 'TITLES.visit_check_in')
                : this.getI18n(i18nKey, 'TITLES.visit_check_out')
        },
        i18nDatetime() {
            return this.mode === 'in'
                ? this.getI18n(i18nKey, 'FIELDS.datetime_in')
                : this.getI18n(i18nKey, 'FIELDS.datetime_out')
        },
        i18nSave() {
            return this.getI18n(i18nCommon, 'save')
        },
        i18nCancel() {
            return this.getI18n(i18nCommon, 'cancel')
        },
        timezone() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone
        },
    },
    validations() {
        return {
            form: {
                datetime: { required },
            },
        }
    },
    methods: {
        showModal({ mode, date, workScheduleId, pointOfSaleId, pointOfSaleName, hash }) {
            this.mode = mode === 'out' ? 'out' : 'in'
            this.context = {
                date,
                workScheduleId,
                pointOfSaleId,
                pointOfSaleName: pointOfSaleName || '',
                hash: hash || null,
            }
            const defaultTime = this.mode === 'in' ? '09:00' : '18:00'
            this.form.datetime = `${date}T${defaultTime}`
            this.submitLoading = false
            this.$v.$reset()
            this.visible = true
        },
        hideModal() {
            this.visible = false
        },
        formattedPayloadDatetime() {
            return moment(this.form.datetime).format('YYYY-MM-DD HH:mm:ss')
        },
        async handleSubmit() {
            this.$v.$touch()
            if (this.$v.$invalid || this.submitLoading) {
                return
            }

            this.submitLoading = true
            try {
                if (this.mode === 'in') {
                    await WorkScheduleVisitCheckService.checkIn(this.context.workScheduleId, {
                        datetime_in: this.formattedPayloadDatetime(),
                        timezone_in: this.timezone,
                    })
                } else {
                    await WorkScheduleVisitCheckService.checkOut(this.context.workScheduleId, {
                        datetime_out: this.formattedPayloadDatetime(),
                        timezone_out: this.timezone,
                        hash: this.context.hash,
                    })
                }
                this.successFeedback(
                    this.i18nTitle,
                    this.getI18n(i18nKey, 'MESSAGES.visit_check_saved')
                )
                this.hideModal()
                this.$emit('saved')
            } catch (error) {
                const message =
                    error?.response?.data?.message ||
                    error?.response?.data?.errors ||
                    this.getI18n(i18nCommon, 'error')
                this.dangerFeedback(this.i18nTitle, typeof message === 'string' ? message : JSON.stringify(message))
            } finally {
                this.submitLoading = false
            }
        },
    },
}
</script>

<template>
    <b-modal
        v-model="visible"
        :title="i18nTitle"
        hide-footer
        centered
        @hidden="hideModal"
    >
        <p v-if="context.pointOfSaleName" class="mb-2">
            {{ context.pointOfSaleName }}
            <span v-if="context.date"> · {{ context.date }}</span>
        </p>
        <b-form @submit.prevent="handleSubmit">
            <b-form-group
                class="required label-pdv"
                :label="i18nDatetime"
                label-for="visit-check-datetime"
                :invalid-feedback="getI18n('ERROR_CODES.invalid')"
                :state="!$v.form.datetime.$error"
            >
                <b-form-input
                    id="visit-check-datetime"
                    v-model="form.datetime"
                    type="datetime-local"
                    class="input-pdv-blue"
                    :state="!$v.form.datetime.$error"
                    @blur="$v.form.datetime.$touch"
                />
            </b-form-group>
            <div class="d-flex justify-content-end">
                <b-button
                    class="btn btn-pdv-gradient-blue-transparent mr-2"
                    :disabled="submitLoading"
                    @click="hideModal"
                >
                    {{ i18nCancel }}
                </b-button>
                <b-button
                    type="submit"
                    class="btn btn-pdv-gradient-blue"
                    :disabled="submitLoading"
                >
                    <b-spinner v-if="submitLoading" small class="mr-1" />
                    {{ i18nSave }}
                </b-button>
            </div>
        </b-form>
    </b-modal>
</template>
